import { useEffect, useState } from 'react';
import "../Css/MobilHadar.css"
import { GiHamburgerMenu } from "react-icons/gi";
import MobileHaderLogo from "../aseets/img/FooterLogo.png"
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom';

function MobileHader() {
  const [show, setShow] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 50) {
          setIsScrolled(true);
        } else {
          setIsScrolled(false);
        }
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
    <div   className={`mobildHaderMainDiv ${isScrolled ? 'scrolled' : ''}`}>
    <div>
           <Link to="/"> <img src={MobileHaderLogo} alt='logo' /></Link>
        </div>
   
    <div>
       
      <div className='hamburgerIcon' onClick={handleShow} >
      <GiHamburgerMenu />
      </div>
      </div>
      </div>

      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title><Link to="/"><img src={MobileHaderLogo} alt='img' /></Link></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className='mobileHaderLink'>
            <Link className='mobileHaderLink' to="/" >Home</Link>
            
          </div>
          <div className='mobileHaderLink'>
            <Link className='mobileHaderLink' to="/about-us" >About Us</Link>
            
          </div>
          <div className='mobileHaderLink'>
            <Link className='mobileHaderLink' to="/membership" >Membership</Link>
            
          </div>
         
          {/* <div className='mobileHaderLink'>
            <Link className='mobileHaderLink' to="/blog" >Blogs</Link>
            
          </div> */}
          <div className='mobileHaderLink'>
            <Link className='mobileHaderLink' to="/testimonial" >Testimonials</Link>
            
          </div>
          <div className='mobileHaderLink'>
            <Link className='mobileHaderLink' to="/contact-us" > Contact Us </Link>
          </div>
          
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default MobileHader;